/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const AudioMediumBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12.5 6.123v11.754l-2.767-2.735a2.5 2.5 0 0 0-1.672-.642H5.5v-5h2.56a2.5 2.5 0 0 0 1.673-.642L12.5 6.123ZM16 14.5c0 .276.232.505.486.397.201-.085.395-.22.574-.397a2.685 2.685 0 0 0 .44-.575c.305-.521.5-1.192.5-1.925 0-.732-.195-1.404-.5-1.925a2.685 2.685 0 0 0-.44-.575 1.856 1.856 0 0 0-.574-.397c-.255-.107-.486.12-.486.397v5ZM14 5v14c0 .866-1.025 1.323-1.669.743L8.73 16.257A1 1 0 0 0 8.06 16H4.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3.56a1 1 0 0 0 .67-.257l3.601-3.486C12.975 3.677 14 4.134 14 5Z" /></svg>);
const AudioMedium = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={AudioMediumBase} {...rest} ref={ref} />);
export default AudioMedium;